import type { GetMissionSectionDataQueryVariables } from '../../models/__generated__/graphql';

export type MissionFilterOptions = Readonly<
  Array<{
    queryParam: string;
    displayValue: string;
    variables?: Partial<GetMissionSectionDataQueryVariables>;
    className?: string;
  }>
>;

// NOTE: Since I had to come back to this and try and remember how it worked
// queryParam is what shows up in our url
// display Value is what shows up in the our dropdowns
// variables is what we're gonna send to graphql to send to BB
export const categories: MissionFilterOptions = [
  { queryParam: '', displayValue: 'All' },
  {
    queryParam: 'internet',
    displayValue: 'Internet',
    variables: { labels: 'Internet' },
  },
  {
    queryParam: 'mobile',
    displayValue: 'Mobile',
    variables: { labels: 'Mobile' },
  },
  {
    queryParam: 'entertainment',
    displayValue: 'Entertainment',
    variables: { labels: 'Entertainment' },
  },
  {
    queryParam: 'sales skills',
    displayValue: 'Sales Skills',
    variables: { labels: 'Sales Skills' },
  },
  {
    queryParam: 'comcast business',
    displayValue: 'Comcast Business',
    variables: { labels: 'Comcast Business' },
  },
  {
    queryParam: 'competitive',
    displayValue: 'Competitive',
    variables: { labels: 'Competitive' },
  },
  {
    queryParam: 'xfinity rewards',
    displayValue: 'Xfinity Rewards',
    variables: { labels: 'Xfinity Rewards' },
  },
  {
    queryParam: 'symphony',
    displayValue: 'Symphony',
    variables: { labels: 'Symphony' },
  },
  // (This label doesn't do anything magical like "load all other labels". It's just literally a label named "Other".)
  {
    queryParam: 'other',
    displayValue: 'Other',
    variables: { labels: 'Other' },
  },
] as const;

export type MissionCategoryDisplayValue =
  (typeof categories)[number]['displayValue'];
